require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/object/get-prototype-of.js
 ** module id = 1087
 ** module chunks = 0
 **/